import React, { useState } from "react";
import { db } from "../../Firebase/firebaseconfig";
import { collection, addDoc, doc, getDoc, setDoc, updateDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import notify from "../common/notify";
import "./NuevoCliente.css";
import { useUserContext } from "../GestionDeUsuarios/UserContext";
import AccessDenied from "../Auth/AccessDenied";
import { registrarAuditoria } from "../../helpers/auditoria";

const NuevoCliente = () => {
  const navigate = useNavigate();
  const { can } = useUserContext();

  const [form, setForm] = useState({
    nombre: "",
    apellidos: "",
    email: "",
    telefono: "",
    direccion: "",
    fechaNacimiento: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const validarFormulario = () => {
    const { nombre, apellidos, email, telefono, direccion, fechaNacimiento } = form;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!nombre || !apellidos || !email || !telefono || !direccion || !fechaNacimiento) {
      notify.error("Por favor completa todos los campos.");
      return false;
    }

    if (!emailRegex.test(email)) {
      notify.error("Correo electrónico inválido.");
      return false;
    }

    return true;
  };

  const obtenerYActualizarFolio = async () => {
    const contadorRef = doc(db, "contadores", "clientes");
    const contadorSnap = await getDoc(contadorRef);
    let nuevoFolio = 1;

    if (contadorSnap.exists()) {
      const { ultimoFolio } = contadorSnap.data();
      nuevoFolio = ultimoFolio + 1;
      await updateDoc(contadorRef, { ultimoFolio: nuevoFolio });
    } else {
      await setDoc(contadorRef, { ultimoFolio: nuevoFolio });
    }

    return nuevoFolio;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!can("clientes.crear")) return;
    if (isSubmitting) return;
    if (!validarFormulario()) return;

    setIsSubmitting(true);

    try {
      const folio = await obtenerYActualizarFolio();
      const nuevoCliente = { ...form, folio };

      const docRef = await addDoc(collection(db, "clientes"), nuevoCliente);
      await registrarAuditoria({
        accion: "clientes.crear",
        entidadTipo: "cliente",
        entidadId: docRef.id,
        despues: nuevoCliente,
      });

      notify.success("Cliente registrado con ID: " + docRef.id);

      navigate("/app/clientes", { replace: true });
    } catch (error) {
      console.error("Error al agregar cliente:", error);
      const code = error?.code || "";
      if (code === "permission-denied") {
        notify.error("No tienes permiso para crear clientes o tocar el contador de folio. Verifica tu rol con el administrador.");
      } else {
        notify.error(`Error al registrar cliente: ${error?.message || code || "intente nuevamente."}`);
      }
      setIsSubmitting(false);
    }
  };

  if (!can("clientes.crear")) {
    return <AccessDenied message="No tienes permiso para crear clientes." />;
  }

  return (
    <div className="nuevo-cliente-container">
      <div className="nuevo-cliente-header">
        <p>Cliente</p>
        <h2>Registrar Nuevo Cliente</h2>
      </div>

      <form onSubmit={handleSubmit} className="form-cliente">
        <div className="form-grid">
          <div className="campo-cliente">
            <label>Nombre</label>
            <input
              type="text"
              name="nombre"
              placeholder="Nombre"
              value={form.nombre}
              onChange={handleChange}
              required
            />
          </div>

          <div className="campo-cliente">
            <label>Apellidos</label>
            <input
              type="text"
              name="apellidos"
              placeholder="Apellidos"
              value={form.apellidos}
              onChange={handleChange}
              required
            />
          </div>

          <div className="campo-cliente">
            <label>Correo electronico</label>
            <input
              type="email"
              name="email"
              placeholder="correo@dominio.com"
              value={form.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="campo-cliente">
            <label>Telefono</label>
            <input
              type="text"
              name="telefono"
              placeholder="Telefono"
              value={form.telefono}
              onChange={handleChange}
              required
            />
          </div>

          <div className="campo-cliente campo-full">
            <label>Direccion / Domicilio / Ubicacion</label>
            <input
              type="text"
              name="direccion"
              placeholder="Direccion"
              value={form.direccion}
              onChange={handleChange}
              required
            />
          </div>

          <div className="campo-cliente">
            <label>Fecha de nacimiento</label>
            <input
              type="date"
              name="fechaNacimiento"
              value={form.fechaNacimiento}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        <div className="form-actions">
          <button type="submit" disabled={isSubmitting}>
            {isSubmitting ? "Guardando..." : "Guardar Cliente"}
          </button>

          <button
            type="button"
            className="cancelar-btn"
            onClick={() => navigate("/app/clientes")}
          >
            Cancelar
          </button>
        </div>
      </form>
    </div>
  );
};

export default NuevoCliente;
